import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ModalId = string;

interface ModalStackState {
  stack: ModalId[];
}

const initialState: ModalStackState = {
  stack: [],
};

// temporary solution before refactoring modalQueue slice
const modalStackSlice = createSlice({
  name: "modalStack",
  initialState,
  reducers: {
    registerModal: (state, action: PayloadAction<ModalId>) => {
      state.stack.push(action.payload);
    },
    unregisterModal: (state, action: PayloadAction<ModalId>) => {
      state.stack = state.stack.filter((id) => id !== action.payload);
    },
  },
});

export const { registerModal, unregisterModal } = modalStackSlice.actions;

export default modalStackSlice.reducer;
